import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <h3>Qazi Absaar</h3>
              <p>AI & IoT Developer passionate about creating innovative solutions</p>
            </div>

            <div className="footer-links">
              <div className="footer-section">
                <h4>Quick Links</h4>
                <ul>
                  <li><button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}>About</button></li>
                  <li><button onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>Projects</button></li>
                  <li><button onClick={() => document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' })}>Experience</button></li>
                  <li><button onClick={() => document.getElementById('skills')?.scrollIntoView({ behavior: 'smooth' })}>Skills</button></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4>Connect</h4>
                <div className="footer-social">
                  <a href="mailto:qaziabsaar1011@gmail.com" aria-label="Email">
                    <Mail size={22} />
                  </a>
                  <a href="https://github.com/QaziAbsaar" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                    <Github size={22} />
                  </a>
                  <a href="https://www.linkedin.com/in/qazi-absaar/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <Linkedin size={22} />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>&copy; {currentYear} Qazi Absaar. All Rights Reserved.</p>
            </div>

            <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
              ↑
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
